module.exports = __webpack_public_path__ + "media/images/apple_health/watch/kinrgy-d6710bad937504fa99a7642a5370afd8.svg";